import { cn } from "@/lib/utils"

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <span
            className={cn(
                "animate-pulseColor inline-block rounded bg-neutral-100",
                className
            )}
            {...props}
        />
    )
}
